module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "V4039_ebook-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-10"
  }, [_vm._v("As ever, special thanks for the terrific anecdotes and great cop talk goes to officers of the Los Angeles Police Department:")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Randy Barr, Jeannine Bedard, Jennifer Blomeley, Adriana Bravo, Kelly Clark, Pete Corkery, Dawna Davis-Killingsworth, Jim Erwin, Brett Goodkin, Jeff Hamilton, Brett Hays, Craig Herron, Jamie Hogg, Mark Jauregui (ret.), Rick Knopf, Rick Kosier (ret.), Fanita Kuljis, Cari Long, Rich Ludwig, Al Mendoza, Buck Mossie, Thongin Muy, Julie Nelson, Scarlett Nuño, Al Pacheco (ret.), Victor Pacheco, Bill Pack, Helen Pallares, Jim Perkins, Robyn Petillo, Kris Petrish (PSR ret.), Brent Smith, Bob Teramura, Rick Wall, Evening Wight")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-11"
  }, [_vm._v("And to officers of the Los Angeles Port Police:")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Kent Hobbs, Ken Huerta, Rudy Meza")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-11"
  }, [_vm._v("And to officers of the San Diego Police Department:")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Michael Belz, Matt Dobbs, Mike Fender, Doru Hansel, Fred Helm, Jeff Jordon, Charles Lara, Lou Maggi, Adam Sharki, Mike Shiraishi, Merrit Townsend, Steve Willard (S.D. Police Historical Association)")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-11"
  }, [_vm._v("And to Debbie Eglin of the San Diego Sheriff’s Department")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-11"
  }, [_c('span', [_vm._v("And to Erik Nava and Ken Nelson of the San Diego District Attorney’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-9"
  }, [_vm._v("And to Mike Matassa (ret.) of the Bureau of Alcohol, Tobacco, Firearms, and Explosives")]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace para-style-override-9"
  }, [_vm._v("And to Danny Brunac, longshoreman of San Pedro")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0023600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4039_ebook5.vue
// module id = 75
// module chunks = 0